import { useContent } from '../content/ContentContext.jsx'
import { Em } from '../components/Em.jsx'
import { SectionNum } from '../components/SectionNum.jsx'

export function EngagementsSection() {
  const { content } = useContent()
  const e = content.engagements
  return (
    <section className="section eng" id="sec-engagements">
      <SectionNum sectionKey="engagements" />
      <h2>
        <Em pre={e.pre} em={e.em} post={e.post} />
      </h2>

      <div className="eng-sub eyebrow">{e.threeTitle}</div>
      <div className="cols3">
        {e.three.map((c) => (
          <div className="engcard" key={c.n}>
            <div className="en">{c.n}</div>
            <h4>{c.title}</h4>
            <p>{c.text}</p>
          </div>
        ))}
      </div>

      <p className="eng-statement">{e.statement}</p>

      <div className="eyebrow">{e.movesTitle}</div>
      <div className="moves">
        {e.moves.map((c) => (
          <div className="move" key={c.n}>
            <div className="mn">{c.n}</div>
            <h4>{c.title}</h4>
            <p>{c.text}</p>
          </div>
        ))}
      </div>

      <div className="houses">
        <div className="eyebrow" style={{ marginBottom: 8 }}>
          {e.housesTitle}
        </div>
        {e.houses.map((h, i) => (
          <div className="hline" key={i}>
            {h}
          </div>
        ))}
      </div>
      <div className="regions">
        <b>{e.regionsPre}</b> — {e.regionsEm}
      </div>
    </section>
  )
}
